import { createContext, useContext, useState, useEffect } from 'react';
import { teamService } from '../services/api';

const TeamContext = createContext(null);

export function TeamProvider({ children }) {
  const [team, setTeam] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTeam = async () => {
      try {
        const response = await teamService.getAll();
        console.log('Team brute:', response.data);
        
        const teamData = response.data.team;
        let teamArray = [];
        
        if (Array.isArray(teamData)) {
          teamArray = teamData;
        } else if (teamData && typeof teamData === 'object') {
          // Convertir l'objet en tableau et filtrer les nulls
          teamArray = Object.values(teamData);
        }
        
        // Filtrer les valeurs null/undefined
        const cleanTeam = teamArray.filter(member => 
          member !== null && 
          member !== undefined && 
          typeof member === 'object' &&
          member.name
        );
        
        console.log('Team nettoyée:', cleanTeam);
        setTeam(cleanTeam);
      } catch (error) {
        console.error('Erreur chargement team:', error);
        setTeam([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTeam();
  }, []);

  return (
    <TeamContext.Provider value={{ team, loading }}>
      {children}
    </TeamContext.Provider>
  );
}

export function useTeam() {
  const context = useContext(TeamContext);
  if (!context) {
    throw new Error('useTeam doit être utilisé dans un TeamProvider');
  }
  return context;
}

export default TeamContext;